export function getCompleteSizes(_ref) {
  let {
    width,
    height
  } = _ref;
  return {
    height,
    maxHeight: height,
    maxWidth: width,
    minHeight: height,
    minWidth: width,
    width
  };
}